<template>
  <SysDialogFullScreen
    v-model="dialog"
    titulo="Dados Compilados da Planilha"
    transition="dialog-bottom-transition"
    @click:hidden-dialog="fechar()"
  >
    <SysDataTable
      :headers="HEADERS_CUSTOM"
      :items="desserts"
      :height="alturaDaJanela - 65"
      :item-height="50"
      hide-default-footer
      class="elevation-1"
    >
      <template #item.mes="{ value }">
        {{ meses[value - 1] }}
      </template>

      <template #item.mes_1="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_2="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_3="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_4="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_5="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_6="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_7="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_8="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_9="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_10="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_11="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_12="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_1="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>
    </SysDataTable>
  </SysDialogFullScreen>
</template>

<script>
import ImportAPI from '../../../api/imports';
import Responsividade from "../../../helpers/ResponsiveHeight";
import SysDialogFullScreen from '../../padraoDeLayout/SysDialogFullScreen.vue';
import SysDataTable from '../../utils/dataTable/sysDataTable/Index.vue';
import Meses from './includes/Meses';
import Headers from "./includes/HeadersTabelaDados";
import moment from 'moment';

export default {
  mixins: [Responsividade],
  components: { SysDialogFullScreen, SysDataTable },
  props: {
    item: {
      type: Object,
      required: true
    },
    dialog_expanded: {
      type: Boolean
    }
  },
  data() {
    return{
      dialog: false,
      meses: Meses,
      desserts: [],
      referencia_data: null
    }
  },
  computed: {
    HEADERS_CUSTOM() {
      let headers = [];

      if (this.dialog_expanded) {
        headers =  Object.assign([], Headers.expanded);
        const array = [0,1,2,3,4,5,6,7,8,9,10,11];

        array.forEach(i => {
          headers.push({
            text: moment(this.item.ano + '-' + this.item.mes).subtract(i, 'month').format('MMM/Y').toUpperCase(),
            value: 'mes_' + (i + 2),
            style: {
              textAlign: 'right',
              maxWidth: '70px',
              minWidth: '70px'
            }
          });
        });
      }
      return headers
    }
  },
  watch: {
    dialog_expanded(valor) {
      if(valor) {
        this.desserts = [];
        this.getDados();
        this.dialog = valor
      }
    }
  },
  methods: {
    fechar() {
      this.$emit('fechar-dialog');
    },
    getDados() {
      const params = this.item;

      this.$store.dispatch("loadingAux/habilitarLoading", true);

      ImportAPI.getDadosExpandedProdutosAnaliseMercado(params)
        .then((response) => {
          const { message, dados, token } = response.data;
          localStorage.setItem("token", token);

          this.desserts = dados;
          this.referencia_data =  dados[0].ano + '-' + dados[0].mes;
        })
        .catch(() => {
          this.Helpers.logout();
        })
        .finally(() => this.$store.dispatch("loadingAux/habilitarLoading", false) );

    }
  }
}
</script>

<style>

</style>
